import { MutationTree } from 'vuex';
import store from '@/store/store';
import { Error } from '@/store/types';
import { Smart, SmartState, DataDevice } from './types';

export const mutations: MutationTree<SmartState> = {
  SMART_SUCCESS: (state, payload: Smart[]) => {
    state.dataDevices = new Array<DataDevice>();
    payload.map((value: Smart, key: number) => {
      state.dataDevices!.push(DataDevice.fromJSON(value));
    });
    // Add phoneNumber
    state.dataDevices.forEach((d: DataDevice) => {
      if (d.gsm && d.gsm.number !== undefined) {
        d.phoneNumber = d.gsm.number;
      } else {
        d.phoneNumber = '';
      }
    });
  },
  SMART_ERROR: (state, payload: Error) => {
    store.commit('alert/SHOW', {
      prefix: 'SMART_ERROR_',
      error: payload.status,
    });
  },

  SMART_ADD_ERROR: (state, payload: Error) => {
    store.commit('alert/SHOW', {
      prefix: 'SMART_ADD_ERROR_',
      error: payload.status,
    });
  },
  SMART_DELETE_ERROR: (state, payload: Error) => {
    store.commit('alert/SHOW', {
      prefix: 'SMART_ERROR_',
      error: payload.status,
    });
  },
  SMART_SYNC_ERROR: (state) => {
    store.commit('alert/SHOW', {
      prefix: 'SMART_SYNC_ERROR_',
      error: 408,
    });
  },
  SMART_ON_SUCCESS: (state, payload: Smart) => {
    state.smart = payload;
    if (state.smart !== undefined) {
      if (state.smart.https !== undefined) {
        window.open(state.smart.https, '_blank');
      } else window.open(state.smart.http, '_blank');
    }
  },
  SMART_ON_ERROR: (state, payload: Error) => {
    state.smart = undefined;
    store.commit('alert/SHOW', {
      prefix: 'SMART_ON_ERROR_',
      error: payload,
    });
  },
  DATA_DEVICE_CREATE: (state) => {
    if (state.dataDevices && state.dataDevices.length === 0) {
      state.dataDevices.push(new DataDevice());
    } else if (
      state.dataDevices &&
      state.dataDevices.length !== 0 &&
      state.dataDevices[state.dataDevices.length - 1]._id &&
      state.dataDevices[state.dataDevices.length - 1]._id !== undefined
    ) {
      state.dataDevices.push(new DataDevice());
    }
  },
  DATA_DEVICE_CANCEL: (state, i) => {
    if (state.dataDevices) state.dataDevices.splice(i, 1);
  },
};
